import { render, staticRenderFns } from "./fujian.vue?vue&type=template&id=269e3e38&scoped=true&"
import script from "./fujian.vue?vue&type=script&lang=js&"
export * from "./fujian.vue?vue&type=script&lang=js&"
import style0 from "./fujian.vue?vue&type=style&index=0&id=269e3e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269e3e38",
  null
  
)

export default component.exports